import { gql } from '@graphql/__generated__';
import type { TourModule } from '@modules/product-updates/tours/tourTypes';

export const LEAD_CMA_ANCHORS = {
  createCma: 'lead-create-cma-report',
} as const;

// A lead of the user where the button shows: a valuation, no CMA yet.
const GET_TOUR_LEAD = gql(/* GraphQL */ `
  query GetLeadOneClickCmaTourLead($userId: uuid!) {
    leads(
      where: {
        lead_agents: { user_id: { _eq: $userId } }
        _not: { cma_reports: {} }
        property: {
          appraisals: {
            _or: [
              { value: { _is_null: false } }
              { min: { _is_null: false }, max: { _is_null: false } }
            ]
          }
        }
      }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
    visible: leads(
      where: {
        _not: { cma_reports: {} }
        property: {
          appraisals: {
            _or: [
              { value: { _is_null: false } }
              { min: { _is_null: false }, max: { _is_null: false } }
            ]
          }
        }
      }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
  }
`);

// One step on the lead page; played by the `cma-one-click-from-lead` campaign.
export const leadOneClickCmaTour: TourModule = {
  steps: t => [
    {
      anchor: LEAD_CMA_ANCHORS.createCma,
      title: t('A CMA report in one click'),
      body: t(
        'This lead has an online valuation: create a CMA report from it in one click, then review and share it with the owner.',
      ),
      placement: 'left',
    },
  ],
  resolvePath: async ({ client, userId }) => {
    const { data } = await client.query({
      query: GET_TOUR_LEAD,
      variables: { userId },
      fetchPolicy: 'network-only',
    });
    // Else one they can see (staff previewing, agents without leads yet).
    const leadId = data?.leads[0]?.id ?? data?.visible[0]?.id;
    return leadId == null ? null : `/leads/${leadId}`;
  },
};
